import React from 'react';

import styled from 'styled-components';

import {ICoach} from '@stryd/models';
import {colors} from '@stryd/react-ui';

import CoachesEntry from './CoachesEntry';

const gutterPadding = '15px';

const getCoachSize = ({coachesPerRow}: {coachesPerRow: number}) => {
  return `${100 / coachesPerRow}%`;
};

const ContainerOuter = styled.div`
  width: 100%;
  padding: calc(2 * ${gutterPadding});
  background-color: ${colors.themes.dark.background};
`;

const ContainerInner = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 -${gutterPadding};
`;

const CoachContainer = styled.div`
  width: ${getCoachSize};
  height: 0;
  padding: ${gutterPadding};
  padding-top: 0;
  padding-bottom: ${getCoachSize};
`;

type CoachesGridProps = {
  activeCoach: ICoach | null;
  coaches: ICoach[];
  coachesPerRow: number;
  onCoachClick: (coach: ICoach) => void;
};

const CoachesGrid: React.FC<React.PropsWithChildren<CoachesGridProps>> = (
  props
) => {
  const {activeCoach, coaches, coachesPerRow, onCoachClick} = props;

  return (
    <ContainerOuter>
      <ContainerInner>
        {coaches.map((coachData) => {
          return (
            <CoachContainer
              coachesPerRow={coachesPerRow}
              key={'coachContainer_' + coachData.email}
            >
              <CoachesEntry
                key={coachData.email}
                handleClick={onCoachClick}
                coach={coachData}
                selected={
                  !!(activeCoach && activeCoach.email === coachData.email)
                }
              />
            </CoachContainer>
          );
        })}
      </ContainerInner>
    </ContainerOuter>
  );
};

export default CoachesGrid;
